// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0
import type { Task } from '@medplum/fhirtypes';

// Mirror of bots/services/claims/constants.ts (frontend cannot import from bots).
export const CLAIM_TASK_SYSTEM = 'http://polarissleep.com/task-types';
export const CLAIM_VALIDATION_TASK_CODE = 'claim-validation-issues';

export interface ClaimValidationIssue {
  /** CMS-1500 form path (`ins.dob`) for form issues, or a resource path (`Coverage.type`) for bot-only checks. */
  field: string;
  message: string;
  /** CMS-1500 box the field lives in, when known. */
  box?: string;
}

/** Extract structured per-field issues from a validation Task's input. */
export function parseValidationIssues(task: Task | undefined): ClaimValidationIssue[] {
  if (!task) {
    return [];
  }
  return (task.input ?? [])
    .map((i) => ({ field: i.type?.text ?? '', message: i.valueString ?? '' }))
    .filter((i) => i.message.length > 0);
}

/** True when a Task is still open (not completed/cancelled). */
export function isOpenClaimTask(task: Task): boolean {
  return task.status !== 'completed' && task.status !== 'cancelled';
}
